export const typecastError = (error, fallbackString)=>{
    try {
        if (typeof error === 'string') {
            return new Error(error);
        }
        if (error instanceof Error) {
            return error;
        }
        if (typeof error === 'object') {
            return new Error(JSON.stringify(error));
        }
        const err = new Error(fallbackString !== null && fallbackString !== void 0 ? fallbackString : 'unhandled error');
        err.cause = error;
        return err;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
        return new Error('Error when typecasting error');
    }
};
export const createAlreadyExistsError = (translate, value)=>{
    return Promise.reject(new Error(translate('error.already_exists', {
        fieldName: value
    })));
};
export const extractApiErrorMessage = (error, fallback = '')=>{
    var _err_response_data_errors_, _err_response_data_errors, _err_response_data, _err_response, _err_response1;
    const err = error;
    return (err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : (_err_response_data_errors = _err_response_data.errors) === null || _err_response_data_errors === void 0 ? void 0 : (_err_response_data_errors_ = _err_response_data_errors[0]) === null || _err_response_data_errors_ === void 0 ? void 0 : _err_response_data_errors_.reason) || (err === null || err === void 0 ? void 0 : (_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : _err_response1.message) || (err === null || err === void 0 ? void 0 : err.message) || fallback;
};
export const extractApiErrorCode = (error, fallback = '')=>{
    var _err_response_data_errors_, _err_response_data_errors, _err_response_data, _err_response;
    const err = error;
    return (err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : (_err_response_data_errors = _err_response_data.errors) === null || _err_response_data_errors === void 0 ? void 0 : (_err_response_data_errors_ = _err_response_data_errors[0]) === null || _err_response_data_errors_ === void 0 ? void 0 : _err_response_data_errors_.code) || fallback;
};
/** Backend WeakPasswordException messages – we show one unified message for any of these. */ const PASSWORD_VALIDATION_REASONS = new Set([
    'Password cannot be empty.',
    'Password must be at least 11 characters long.',
    'Password must contain at least one uppercase letter.',
    'Password must contain at least one lowercase letter.',
    'Password must contain at least one number.',
    'Password must contain at least one special character.',
    'Password is too weak or commonly used.'
]);
/**
 * For password flows only:
 * - when reason is in PASSWORD_VALIDATION_REASONS, returns both a unified message (primary)
 *   and specific reason (secondary) so callers can show two toasts.
 * - otherwise returns only primary with API message/fallback.
 */ export const getPasswordFormErrorMessage = (error, unifiedMessage, fallback)=>{
    var _err_response_data_errors_, _err_response_data_errors, _err_response_data, _err_response;
    const err = error;
    const reason = err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : (_err_response_data_errors = _err_response_data.errors) === null || _err_response_data_errors === void 0 ? void 0 : (_err_response_data_errors_ = _err_response_data_errors[0]) === null || _err_response_data_errors_ === void 0 ? void 0 : _err_response_data_errors_.reason;
    if (reason != null && PASSWORD_VALIDATION_REASONS.has(reason)) {
        return {
            primary: unifiedMessage,
            secondary: reason
        };
    }
    if (reason != null) {
        return {
            primary: extractApiErrorMessage(error, fallback)
        };
    }
    return {
        primary: fallback
    };
};
